import { createSlice } from '@reduxjs/toolkit';

export const ExpressCheckinSlice = createSlice({
  name: 'expressCheckin',
  initialState: {
    expressCheckinList: [],
    expressCheckin: {},
  },
  reducers: {
    setExpressCheckinListRedux: (state, { payload }) => {
      state.expressCheckinList = payload;
    },
    storeExpressCheckinRedux: (state, { payload }) => {
      state.expressCheckin = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setExpressCheckinListRedux, storeExpressCheckinRedux } = ExpressCheckinSlice.actions;
